import { render, staticRenderFns } from "./alunos-presentes.vue?vue&type=template&id=67e24b3a"
import script from "./alunos-presentes.vue?vue&type=script&lang=js"
export * from "./alunos-presentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports